<template>
    <div>
        <events-grid :showHideButton="showHideButton"
                     :showPinButton="showPinButton"
                     :showNewButton="showNewButton"
                     :showResizeIcon="showResizeIcon"
                     :size="size"
                     :showSettingsBtn="showSettingsBtn"
                     :showBtns="showBtns"
                     :titleKey="titleKey"
                     :showImportFromExcelButton="true"
                     :registerName="registerName"
                     :archived="archived"
                     :title="title">
        </events-grid>
    </div>
</template>

<script>
    import EventsGrid from "@/components/dynamic/events/EventsGrid";
    export default {
        name: 'list-dynamic-data',
        components: {
            EventsGrid
        },
        props: {
            // Пропъртита, които трабват на компонента с бутоните за дашборд настройките
            registerName: {
                default: '',
                type: String
            },
            // Определя дали да се покажат архивираните събития
            archived: {
                type: Boolean,
                default: false
            },
            // Пропъртита, които трабват на компонента с бутоните за дашборд настройките
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            title: {
                type: String,
                default: 'sideMenu.events'
            }
        },
        data() {
            return {
                titleKey: 'registers.' + this.registerName + '.title', // Трабва на конпонентата за бутоните за дашборд настройките
            };
        },

        methods: {

        },
        mounted: function () {

        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
        }
    }
</script>

<style scoped>
</style>
